import React from "react";
import { FileText, Palette, Image, FolderOpen } from "lucide-react";

/**
 * Modern workspace mode tabs (Text, Drawing, Images, Documents)
 */
const WorkspaceTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: "text", label: "Text", icon: FileText },
    { id: "draw", label: "Drawing", icon: Palette },
    { id: "image", label: "Images", icon: Image },
    { id: "document", label: "Documents", icon: FolderOpen },
  ];

  return (
    <div className="bg-slate-100/80 p-1.5 rounded-xl border border-slate-200">
      <nav className="grid grid-cols-2 sm:grid-cols-4 gap-1.5" aria-label="Workspace tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold
                transition-all duration-200 select-none
                ${
                  isActive
                    ? "bg-white text-slate-900 shadow-sm border border-slate-200 ring-1 ring-slate-950/5"
                    : "text-slate-600 hover:text-slate-900 hover:bg-slate-200/60"
                }
              `}
            >
              <Icon className={`w-4 h-4 shrink-0 ${isActive ? "text-indigo-600" : "text-slate-400"}`} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default WorkspaceTabs;
